import { useSession } from './session-context';
import { useLanguage } from './language-context';
import { surfaceOrigin } from './surface-links';
import type { MessageKey } from '@bookingdei/i18n/message-key';

// The other dashboards this account can open (M32; one sign-in, no sign-out — client
// decision 30 Oct 2026, amending DR-38): the customer dashboard always (everyone can
// act as a customer, DB-1), the admin console for an admin. Plain links, one row each,
// so the way back to the customer side is never hidden behind a second popover. The
// target dashboard takes its role by itself on load (API-13 switch-role), so nothing
// is switched here — a merchant tab left open keeps working. Duplicated per surface
// (CB-D3).
export function AccountSwitcher() {
  const { user } = useSession();
  const { t } = useLanguage();
  if (!user) return null;

  const links: Array<{ key: MessageKey; href: string }> = [];
  const app = surfaceOrigin('app');
  if (app) links.push({ key: 'account.switch_customer', href: `${app}/` });
  const admin = surfaceOrigin('admin');
  if (admin && (user.roles ?? []).includes('admin')) links.push({ key: 'account.switch_admin', href: `${admin}/` });
  if (links.length === 0) return null;

  return (
    <>
      {links.map((link) => (
        <a key={link.key} role="menuitem" className="acct__item acct-switch__link" href={link.href}>
          <span className="acct-switch__glyph" aria-hidden="true">
            ⇄
          </span>
          <span>{t(link.key)}</span>
        </a>
      ))}
    </>
  );
}
